/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Feature_ScreenshotInputs */



/**
* | output |
* | --- |
* | "{title} feature screenshot" |
*
* @param {Feature_ScreenshotInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const feature_screenshot = /** @type {((inputs: Feature_ScreenshotInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feature_ScreenshotInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Capture d’écran de la fonctionnalité ${i?.title}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Screenshot der ${i?.title}-Funktion`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Schermata della funzionalità ${i?.title}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Скриншот функции ${i?.title}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Captura de pantalla de la función ${i?.title}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.title} 功能截图`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.title} 機能のスクリーンショット`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.title} फ़ीचर स्क्रीनशॉट`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Captura de tela do recurso ${i?.title}`)
	return /** @type {LocalizedString} */ (`${i?.title} feature screenshot`)
});